import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { SeoHandlerClass } from '@Src/utils/seo-handler.class';
import { LearningSchemas } from '@Constants/constants';

export const RouteChangeSubscription = () => {
    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [seoDetails, setSeoDetails] = useState<any>(null)
    const [structuredJSON, setStructuredJSON] = useState<any>();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        window.scrollTo(0, 0);
        (async () => {
            const seoHandler = new SeoHandlerClass(pathname);
            const fetchedSeoDetails = await seoHandler.getSeoDetails(pathname);
            setSeoDetails({ ...fetchedSeoDetails });

        })();
    }, [pathname, searchParams]);

    useEffect(() => {
        if (pathname == "/") {
            let JSONProduct = '';
            let productSchema = LearningSchemas;
            if (productSchema) {
                JSONProduct = productSchema;
                setStructuredJSON(JSONProduct)
            }
        } else {
            setStructuredJSON(null)
        }
    }, [pathname])


    return (<><Helmet>
        <title>{seoDetails?.title || 'Taxmann'}</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="keywords" content={seoDetails?.keywords} />
        <meta name="description" content={seoDetails?.description} />
        <meta name="robots" content={location.hostname.indexOf('www') !== -1 ? (seoDetails?.robots || 'noindex, nofollow') : 'noindex, nofollow'} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="https://www.taxmann.com" />
        <meta property="og:title" content={seoDetails?.og?.title || seoDetails?.title} />
        <meta property="og:description" content={seoDetails?.og?.description || seoDetails?.description} />
        <meta property="og:image" content={seoDetails?.og?.image || seoDetails?.image || 'https://cdn.taxmann.com/learnings/Learning-Logo.png'} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="taxmann.com" />
        <meta property="twitter:url" content={window.location.href} />
        <meta name="twitter:site" content="@taxmannindia" />
        <meta name="twitter:title" content={seoDetails?.og?.title || seoDetails?.title} />
        <meta name="twitter:description" content={seoDetails?.og?.description || seoDetails?.description} />
        <meta name="twitter:image" content={seoDetails?.og?.image || seoDetails?.image || 'https://cdn.taxmann.com/learnings/Learning-Logo.png'} />
        {structuredJSON ? <script className='structured-data-list' type="application/ld+json">
            {structuredJSON}
        </script> : null}
    </Helmet></>)
}
